import { withInstall } from '../utils'

import Com from './src/index.vue'

export const NumericalTrend = withInstall(Com)
